import {
    DiCss3,
    DiHtml5,
    DiJsBadge,
    DiReact,
    DiNodejsSmall,
    DiPostgresql,
} from 'react-icons/di';
import {
    SiTypescript,
    SiNextdotjs,
    SiTailwindcss,
    SiRedux,
    SiReacthookform,
    SiDotnet,
    SiSharp,
    SiSupabase,
    SiFlutter,
    SiDart,
    SiFirebase,
    SiSocketdotio,
    SiDocker,
    SiGithubactions,
    SiGit,
    SiPrisma,
    SiShadcnui,
    SiVite,
    SiFastify,
    SiZod,
} from 'react-icons/si';
import { VscAzureDevops } from 'react-icons/vsc';

export const stack = {
    react: { name: 'React', icon: DiReact },
    typescript: { name: 'TypeScript', icon: SiTypescript },
    nextjs: { name: 'Next.js', icon: SiNextdotjs },
    javascript: { name: 'JavaScript', icon: DiJsBadge },
    rhf: { name: 'React Hook Form', icon: SiReacthookform },
    redux: { name: 'Redux', icon: SiRedux },
    tailwind: { name: 'Tailwind', icon: SiTailwindcss },
    html: { name: 'HTML', icon: DiHtml5 },
    css: { name: 'CSS', icon: DiCss3 },
    shadcn: { name: 'shadcn/ui', icon: SiShadcnui },
    vite: { name: 'Vite', icon: SiVite },
    fastify: { name: 'Fastify', icon: SiFastify },
    zod: { name: 'Zod', icon: SiZod },
    nodejs: { name: 'Node.js', icon: DiNodejsSmall },
    dotnet: { name: '.NET', icon: SiDotnet },
    csharp: { name: 'C#', icon: SiSharp },
    postgres: { name: 'PostgreSQL', icon: DiPostgresql },
    supabase: { name: 'Supabase', icon: SiSupabase },
    prisma: { name: 'Prisma', icon: SiPrisma },
    flutter: { name: 'Flutter', icon: SiFlutter },
    dart: { name: 'Dart', icon: SiDart },
    firebase: { name: 'Firebase', icon: SiFirebase },
    fcm: { name: 'FCM', icon: SiFirebase },
    websocket: { name: 'WebSocket', icon: SiSocketdotio },
    signalr: { name: 'SignalR', icon: SiDotnet },
    docker: { name: 'Docker', icon: SiDocker },
    githubActions: { name: 'GitHub Actions', icon: SiGithubactions },
    azureDevops: { name: 'Azure DevOps', icon: VscAzureDevops },
    git: { name: 'Git', icon: SiGit },
};
